module.exports = __webpack_public_path__ + "static/media/IEmpresa.453b5cb6.svg";